module.exports = __webpack_public_path__ + "static/images/cash.3P60QNo.svg";